import React from 'react'

const SideMenuSection = ({ title, children }) => {
  return (
    <div className='side-menu-section'>
      <h2>{title}</h2>
      {children}
    </div>
  )
}

export default SideMenuSection